import "./NavBar.scss";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

const NavBar = ({ currentPage }) => {
  const [heavenlyBody, setHeavenlyBody] = useState("");

  useEffect(() => {
    let currentTheme = window.localStorage.getItem("mu-portfolio--theme");
    if (!currentTheme) {
      currentTheme = "dark";
      window.localStorage.setItem("mu-portfolio--theme", currentTheme);
      document.documentElement.dataset.theme = currentTheme;
    }
    setHeavenlyBody(currentTheme === "dark" ? "moon" : "sun");
  }, []);

  const toggleTheme = () => {
    const html = document.documentElement;
    if (html.dataset.theme == "light") {
      window.localStorage.setItem("mu-portfolio--theme", "dark");
      html.dataset.theme = "dark";
      setHeavenlyBody("moon");
    } else {
      window.localStorage.setItem("mu-portfolio--theme", "light");
      html.dataset.theme = "light";
      setHeavenlyBody("sun");
    }
  };

  return (
    <>
      <div className="navbar">
        <ul className="navbar-list">
          <li>
            <ul className="menu-links">
              <li className={`${currentPage === "home" ? "selected" : ""}`}>
                <a href="/Portfolio"> Home </a>
              </li>

              <li className={`${currentPage === "about" ? "selected" : ""}`}>
                <a href="/Portfolio/about"> About </a>
              </li>

              <li className={`${currentPage === "projects" ? "selected" : ""}`}>
                <a href="/Portfolio/projects"> Projects </a>
              </li>

              <li
                className={`${currentPage === "experience" ? "selected" : ""}`}
              >
                <a href="/Portfolio/experience"> Experience </a>
              </li>

              <li>
                <div className="theme-toggle" onClick={toggleTheme}>
                  <div className={heavenlyBody}> </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="line"> </div>
    </>
  );
};

NavBar.propTypes = {
  currentPage: PropTypes.string.isRequired,
};

export default NavBar;
